import PropTypes from 'prop-types'

import {
  PIPING_MASK_REGEX,
  QUESTION_TITLE_PIPING_THUMB_WIDTH,
  QUESTION_TITLE_PIPING_THUMB_HEIGHT
} from '@aytm/app/stats/page/comments/lib/constants'

import { removeLogicFromText } from '@aytm/app/stats/page/components/lib/utils'

import ImagePopup from '@aytm/app/stats/components/image-popup/ImagePopup'

import style from '@aytm/app/stats/page/comments/comments/styles/OEQuestionTitle.module.scss'
import { ALLOWED_HTML_TAGS } from '@aytm/app/stats/page/components/lib/constants'

const OEQuestionTitle = ({ pipingMask, questionText, nodeOptions, imagesData }) => {
  let resultText = (pipingMask && pipingMask[`___${nodeOptions.value}t`]) || questionText
  let thumbPreview = null

  const renderQuestionThumbnail = image => (
    <div className={style['comment-header-question-title-thumbnail']}>
      <ImagePopup image={image} width={QUESTION_TITLE_PIPING_THUMB_WIDTH} height={QUESTION_TITLE_PIPING_THUMB_HEIGHT} />
    </div>
  )

  if (nodeOptions.image) {
    if ('string' == typeof nodeOptions.image) {
      if (imagesData[nodeOptions.image]) {
        thumbPreview = renderQuestionThumbnail(imagesData[nodeOptions.image])
      }
    } else {
      thumbPreview = renderQuestionThumbnail(nodeOptions.image)
    }
  }

  if ('string' == typeof resultText) {
    resultText.match(PIPING_MASK_REGEX)?.forEach(matchedItem => {
      const key = matchedItem.match(/\[(.*)]/i)[1].toLowerCase()
      const mask = key && pipingMask ? pipingMask[key.toLowerCase()] : null
      if (mask) {
        if (mask.original_url) {
          resultText = resultText.replace(matchedItem, '')
          thumbPreview = renderQuestionThumbnail(mask)
        } else {
          resultText = resultText.replace(matchedItem, mask)
        }
      }
    })

    resultText = removeLogicFromText(resultText)
    if (ALLOWED_HTML_TAGS.test(resultText)) {
      resultText = <span dangerouslySetInnerHTML={{ __html: resultText }} />
    }
  }

  return (
    <>
      {thumbPreview}
      <strong className={style['comment-header-question-title-name']}>{nodeOptions.prefix}: </strong>
      {resultText}
    </>
  )
}

OEQuestionTitle.propTypes = {
  pipingMask: PropTypes.object,
  questionText: PropTypes.string,
  nodeOptions: PropTypes.object,
  imagesData: PropTypes.object
}

OEQuestionTitle.displayName = 'QuestionTitle'

export default OEQuestionTitle
